import React, { type PropsWithChildren } from 'react'
import { useS4LContext } from '@s4l/react-context'

import styles from './styles.module.css'
import { IconWarningMsg } from '@s4l/icons/IconWarningMsg'

export interface IGuestRoomListMessageProps {
  totalGuests: number
  isEnabled: boolean
}

const VoucherGuestRoomListMessage = ({
  children,
  totalGuests,
  isEnabled,
}: PropsWithChildren<IGuestRoomListMessageProps>) => {
  const { i18n } = useS4LContext()

  if (!isEnabled) {
    return null
  }

  return (
    <div className={styles.container}>
      <span className={styles.title}>
        <IconWarningMsg data-testid="guest-room-list-message-icon" />
        {i18n.formatMessage(
          {
            id: 'guest-rooming-list-banner.title',
          },
          { count: totalGuests }
        )}
      </span>

      <p className={styles.body}>
        {i18n.formatMessage({
          id: 'guest-rooming-list-banner.body',
        })}
      </p>

      <div className={styles.children}>{children}</div>
    </div>
  )
}

export default VoucherGuestRoomListMessage
